<template>
    <div>
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="formularios-list vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('formulario-consulta') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">
                                            {{ $t($route.meta.contexto) }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">
                                            {{
                                                $route.meta.abrev == 'pro'
                                                    ? $t('cadastros')
                                                    : $t('formulario')
                                            }}
                                        </a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('meus-formularios') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">

                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="changeSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="formularios-table registry-wrapper">
                        <container-loader v-if="isLoading && !$store.getters.isLoading" />
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="formularios"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :mlLabels="true"
                                :class="{
                                    'excluir-field': f.key == 'excluir',
                                }"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.update"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>

                                <div v-else-if="f.key == 'titulo'">
                                    <router-link
                                        :to="{
                                            name: `${abrev}formulario-consulta-edit`,
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'criado-em'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>

                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import FormularioService from '@/services/FormularioService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada.
 */
export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes('formulario-consulta') &&
            !to.name.includes('formulario-consulta-list')
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            formularios: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new FormularioService(this.$http, this.$router),
            sURL: null,
            fields: [
                { key: 'codigo', width: '15%', sortable: false, sortFn: null },
                { key: 'titulo', width: null, sortable: true, sortFn: null },
                { key: 'criado-em', width: 140, sortable: true, sortFn: this.sortCriadoEm },
                { key: 'situacao', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            deleteThis: {},
            debouncedOnSearch: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'titulo',
            order: 'asc',
            abrev: '',
        };
    },
    created() {
        if (
            this.$route.name.includes('formulario-consulta') &&
            !this.$route.name.includes('formulario-consulta-list')
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.contexto = this.$route.meta.contexto.slice(0, 3);

        if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'cadastros',
                'formulario-consulta'
            );
        } else if (this.$route.meta.abrev == 'ven') {
            this.abrev = this.$route.meta.contexto.slice(0, 3) + '-';
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'formulario',
                'ven-formulario-consulta'
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'meus-formularios' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.contexto,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((formularios) => {
                    this.formularios = formularios;
                    this.isEmpty = this.formularios.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let formularios = [];
            if (body.content) {
                formularios = body.content.map((f) => {
                    return {
                        id: f.idformulario,
                        codigo: f.idformularioerp,
                        titulo: f.titulo,
                        descricao: f.descricao,
                        'criado-em': f.datahorainc,
                        excluir: 'excluir-formulario',
                        situacao: f.situacao,
                    };
                });
            }
            return formularios;
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacao() {
            let formulario = {
                idformulario: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.service
                .updateSituacao(formulario, this.contexto)
                .then((r) => {
                    if (r.status == 200) {
                        let messageSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar'
                                    : 'msg-sucesso-ao-desativar', 
                                { n: this.$t('formulario') }
                            );

                        this.$root.showMessage('success', messageSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);

                    let messageFail = this.$t(
                            this.delete.situacao == 1
                                ? 'msg-erro-ao-desativar'
                                : 'msg-erro-ao-reativar', 
                            { n: this.$t('formulario') }
                        );

                    this.$root.showMessage('error', messageFail, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        //   excluir() {
        //     let item = this.deleteThis;
        //     this.isLoading = true;
        //     this.service.delete(item.id, this.contexto)
        //       .then(_ => {
        //         this.$root.showMessage('success', 'msg-success-excluir-formulario');
        //         this.carregarDados(this.pagination.currentPage);
        //       })
        //       .catch(e => {
        //         console.error('Erro ao excluir formulario.', e);
        //         this.$root.showMessage('error', 'msg-failure-excluir-formulario');
        //         this.isLoading = false;
        //       })
        //       .finally(_ => {
        //         this.deleteThis = null;
        //       });
        //   },
        changeSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        parseDateString(d) {
            let a = d.split('T')[0].split('-');

            return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString();
        },
        sortCriadoEm(a, b, isAsc) {
            let da = a['criado-em'].split('/').reverse().join('-');
            let db = b['criado-em'].split('/').reverse().join('-');

            if (isAsc) {
                return new Date(da).getTime() - new Date(db).getTime();
            } else {
                return new Date(db).getTime() - new Date(da).getTime();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .formularios-list .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .formularios-list .search-and-filter {
        .search-bar {
            width: 80%;
        }

        .item-input {
            width: 19%;

            > .v-select {
                height: 38px;
            }
        }
    }

    .formularios-list .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
